import { Button } from '@/components/ui/Button';

interface SaveBarProps {
  visible: boolean;
  onSave: () => void;
  onDiscard: () => void;
  saving?: boolean;
  disabledReason?: string;
}

/**
 * Sticky confirmation bar shown when a settings form has unsaved local
 * changes. Not in docs/DESIGN_SYSTEM.md's component list verbatim, but
 * built from the same Button primitive — appears above the mobile bottom
 * nav (bottom-16 on mobile, bottom-4 on desktop) so it never overlaps it.
 */
export function SaveBar({ visible, onSave, onDiscard, saving, disabledReason }: SaveBarProps) {
  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-16 md:bottom-4 z-20 flex justify-center px-4">
      <div className="bg-bg-elevated border border-border-subtle rounded-md shadow-md px-4 py-3 flex items-center gap-3 max-w-lg w-full md:w-auto">
        <p className="text-small text-text-secondary flex-1">
          {disabledReason ?? 'You have unsaved changes.'}
        </p>
        <Button variant="ghost" size="sm" onClick={onDiscard} disabled={saving}>
          Discard
        </Button>
        <Button variant="primary" size="sm" onClick={onSave} disabled={saving || !!disabledReason}>
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </div>
    </div>
  );
}
